import { render, staticRenderFns } from "./FreeCanvasWorkspace.vue?vue&type=template&id=0ba1b716&scoped=true"
import script from "./FreeCanvasWorkspace.vue?vue&type=script&lang=js"
export * from "./FreeCanvasWorkspace.vue?vue&type=script&lang=js"
import style0 from "./FreeCanvasWorkspace.vue?vue&type=style&index=0&id=0ba1b716&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba1b716",
  null
  
)

export default component.exports